import React, {useEffect} from "react";
import {useStyles} from "./styles/OddStepSixStyle";
import {
    Box,
    Typography,
    Tabs,
    Tab,
    IconButton, FormControl, Select, MenuItem
} from "@material-ui/core";
import PropTypes from 'prop-types';
import { ReactComponent as AccentVolumeIcon } from '../../../../../common/images/AccentVolumeIcon.svg';
import { ReactComponent as AccentVolumeDisableIcon } from '../../../../../common/images/AccentVolumeDisableIcon.svg';
import { ReactComponent as ArrowDownIcon } from '../../../../../common/images/ArrowDownIcon.svg';
import { ReactComponent as RefreshIcon } from '../../../../../common/images/RefreshIcon.svg';
import { ReactComponent as RefreshDisableIcon } from '../../../../../common/images/RefreshDisableIcon.svg';
import {withRouter} from "react-router-dom";
import {inject, observer} from "mobx-react";
import {VoiceType} from "../../../../../common/enums/VoiceType";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function OddStepSix(props) {
    const classes = useStyles();

    const {contentStore,oddStepSixStore} = props;
    const {stepValue, dayValue} = props.contentStore;

    const handleChange = (event, newValue) => {
        oddStepSixStore.setContentTapIndex(newValue);
        oddStepSixStore.stopAudio();
        oddStepSixStore.setIsProcessing(false);
    };


    const onSave = () => {
        oddStepSixStore.modifyOddStepSixContent(stepValue, dayValue, () => {
            oddStepSixStore.getOddStepSixContent(stepValue, dayValue, processOddStepSixContent);
            contentStore.setReadyToSaveStep(false);
        });
    }

    const processOddStepSixContent = (res) => {
        const isCompleted = oddStepSixStore.isOddStepFourCompleted(res);
        contentStore.setReadyToMoveExit(isCompleted);
    }

    useEffect(() => {
        oddStepSixStore.getOddStepSixContent(stepValue, dayValue, processOddStepSixContent)
        contentStore.setOnSave(onSave);
        return ()=> {
            contentStore.setOnSave(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getMainText = () => {
        if (oddStepSixStore.content) {
            return oddStepSixStore.content.mainText;
        } else {
            return '';
        }
    }

    const handleClickAudio = () => {
        oddStepSixStore.playAudio();
    }

    const handleChangeVoiceType = (e) => {
        oddStepSixStore.changeVoiceType(e.target.value);
    }

    const handleRefreshTTS = () => {
        oddStepSixStore.stopAudio();

        const country = oddStepSixStore.getSelectedCountryCode();
        contentStore.getGeneratedTTSWithAzure(country, oddStepSixStore.getVoiceType(country), getMainText(), (audio) => oddStepSixStore.changeAudio(audio.split(',')[1]));
        contentStore.setReadyToSaveStep(true);
    }

    return (
        <div className={classes.root}>
            <Box className={classes.boxWrap}>
                <Box>
                    <Box position="static" className={classes.tabBox}>
                        <Tabs value={oddStepSixStore.contentTapIndex} onChange={handleChange} aria-label="simple tabs example">
                            <Tab label="원문(미국)" {...a11yProps(0)} disableRipple/>
                            <Tab label="영국" {...a11yProps(1)} disableRipple/>
                            <Tab label="호주" {...a11yProps(2)} disableRipple/>
                        </Tabs>
                    </Box>
                    <TabPanel key={0} value={oddStepSixStore.contentTapIndex} index={0} className={classes.textBox}>
                        <Box display={"flex"} justifyContent={"flex-first"} alignItems={"center"} sx={{marginTop: 10}}>
                            <FormControl className={classes.formControl}>
                                <Select
                                    disabled={true}
                                    value={oddStepSixStore.content ? oddStepSixStore.content.mainVoiceType : VoiceType.MAN}
                                    IconComponent={(props) => (
                                        <Box>
                                            <ArrowDownIcon  {...props} />
                                        </Box>
                                    )}
                                    MenuProps={{
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "right"
                                        },
                                        transformOrigin:{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        },
                                        getContentAnchorEl: null,
                                        className:classes.selectPopover
                                    }}
                                >
                                    <MenuItem value='Man'>성인남성</MenuItem>
                                    <MenuItem value='Woman'>성인여성</MenuItem>
                                    <MenuItem value='Child'>아이</MenuItem>
                                    <MenuItem value='Elderly'>노인</MenuItem>
                                </Select>
                            </FormControl>
                            <>
                                <IconButton className={classes.volumeIcon} style={{cursor: 'default'}} disableRipple>
                                    <RefreshDisableIcon />
                                </IconButton>
                            </>
                        </Box>
                        <Box className={classes.englishAccentBox}>
                            <Typography>{getMainText()}</Typography>
                            <IconButton className={classes.englishVolumeBtn} disableRipple onClick={handleClickAudio}>
                                {oddStepSixStore.content && oddStepSixStore.content.mainAudio !== null ?
                                    <AccentVolumeIcon />
                                    :
                                    <AccentVolumeDisableIcon style={{cursor: 'default'}} />
                                }
                            </IconButton>
                        </Box>
                    </TabPanel>
                    {oddStepSixStore.content && oddStepSixStore.content.audios.map((audio, index) => {
                        return (
                                <TabPanel key={index + 1} value={oddStepSixStore.contentTapIndex} index={index + 1} className={classes.textBox}>
                                    <Box display={"flex"} justifyContent={"flex-first"} alignItems={"center"} sx={{marginTop: 10}}>
                                        <FormControl className={classes.formControl}>
                                            <Select
                                                disabled
                                                value={oddStepSixStore.getVoiceType(audio.country)}
                                                onChange={handleChangeVoiceType}
                                                IconComponent={(props) => (
                                                    <Box>
                                                        <ArrowDownIcon  {...props} />
                                                    </Box>
                                                )}
                                                MenuProps={{
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "right"
                                                    },
                                                    transformOrigin:{
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    },
                                                    getContentAnchorEl: null,
                                                    className:classes.selectPopover
                                                }}
                                            >
                                                <MenuItem value='Man'>성인남성</MenuItem>
                                                <MenuItem value='Woman'>성인여성</MenuItem>
                                                <MenuItem value='Child'>아이</MenuItem>
                                                <MenuItem value='Elderly'>노인</MenuItem>
                                            </Select>
                                        </FormControl>
                                        <>
                                            <IconButton className={classes.volumeIcon} disableRipple onClick={handleRefreshTTS}>
                                                <RefreshIcon />
                                                {/*<RefreshDisableIcon />*/}
                                            </IconButton>
                                        </>
                                    </Box>
                                    <Box className={classes.englishAccentBox}>
                                        <Typography>{getMainText()}</Typography>
                                        <IconButton className={classes.englishVolumeBtn} disableRipple onClick={handleClickAudio}>
                                            {audio.audio !== null ?
                                                <AccentVolumeIcon />
                                                :
                                                <AccentVolumeDisableIcon style={{cursor: 'default'}} />
                                            }
                                        </IconButton>
                                    </Box>
                                </TabPanel>
                            )})}
                </Box>
            </Box>

        </div>
    );
}

export default withRouter(inject('contentStore','oddStepSixStore')(observer(OddStepSix)));
